<nav class="navbar fixed-top navbar-expand-lg bg-white shadow-sm">
    <div class="container">
        <div class="row w-100">
            <div class="col-4 d-flex justify-content-start align-items-center">
                <img alt="" class="p-2" height="80" ngSrc="assets/images/logos/logo-lg.png" width="98.77" priority/>
            </div>
            <div class="col-4 d-flex justify-content-center align-items-center">
                <a class="navbar-brand fw-bolder fs-2 p-0 m-0" routerLink="/"> Apisat </a>
            </div>
            <div class="col-4 d-flex justify-content-end align-items-center">
                @if (userIsAdmin() && !isAdminPage()) {
                    <a routerLink="/admin"> Administration </a>
                }
            </div>
        </div>
    </div>
</nav>
